import React from 'react';
import { TouchableOpacity } from 'react-native-web';

//= ========================================================================

const SquareBar = ({ isSelected, onPress }) => (
  <TouchableOpacity
    style={{
      height: 50,
      width: 150,
      marginEnd: 12,
      borderRadius: 6,
      border: isSelected ? 'solid 2px #008cff' : 'solid 0.6px #cbd5e0',
      boxShadow: '0 0 10px 0 rgba(0, 109, 199, 0.12)',
    }}
    onPress={onPress}
  />
);
export default SquareBar;
